import { render, staticRenderFns } from "./AdminCore.vue?vue&type=template&id=328be93e&scoped=true"
import script from "./AdminCore.vue?vue&type=script&lang=js"
export * from "./AdminCore.vue?vue&type=script&lang=js"
import style0 from "./AdminCore.vue?vue&type=style&index=0&id=328be93e&prod&lang=less"
import style1 from "./AdminCore.vue?vue&type=style&index=1&id=328be93e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328be93e",
  null
  
)

export default component.exports